export { default } from '@fhs-legacy/frontend/src/pages/static';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';
